import { apiService } from '@/services/api/api.service';
import type {
  FileResultResponse,
  FileImageResponse,
  FileNotesResponse,
  FileAnomalyResponse,
  FileMRZResponse,
} from '@/features/analysis/types/api.types';

export const analysisApi = {
  // GET LIST

  getResult: async (fileId: string): Promise<FileResultResponse> => {
    const response = await apiService.get(`/p2/get_result/${fileId}`);
    return response as FileResultResponse;
  },

  getImage: async (fileId: string): Promise<FileImageResponse> => {
    const response = await apiService.get(`/p2/get_image/${fileId}`);
    return response as FileImageResponse;
  },

  getNotes: async (fileId: string): Promise<FileNotesResponse> => {
    const response = await apiService.get(`/p2/get_notes/${fileId}`);
    return response as FileNotesResponse;
  },

  getAnomaly: async (
    fileId: string,
    pageIndex: number
  ): Promise<FileAnomalyResponse> => {
    const response = await apiService.get(
      `/p2/get_tab_anomaly/${fileId}/${pageIndex}`
    );
    return response as FileAnomalyResponse;
  },

  getMRZ: async (
    fileId: string,
    pageIndex: number
  ): Promise<FileMRZResponse> => {
    const response = await apiService.get(
      `/p2/get_tab_mrz/${fileId}/${pageIndex}`
    );
    return response as FileMRZResponse;
  },

  getDownload: async (fileId: string): Promise<Blob> => {
    const response: Blob = await apiService.getBlobWithoutFilename(
      `/p2/download/${fileId}`
    );
    return response;
  },

  // POST List

  checkMRZ: async (mrz: string[]): Promise<boolean> => {
    const response: boolean = await apiService.post(`/p2/check_mrz`, {
      fields: mrz,
    });
    return response;
  },

  reportBug: async (fileId: string, message: string): Promise<void> => {
    await apiService.post(`/p2/report/${fileId}`, { message });
  },
};
